import { dataGoods } from '../../MainPage/GoodsList/dataGoods.js';

import { GoodsSlider } from './GoodsSlider';

export const SliderSection = () => {
  const getRandomValue = (array) => Math.floor(Math.random() * array.length);
  const getRamdomGoods = () => {
    const randomArray = [];
    const GOODS_ROW = 3;
    for (let i = 0; i < GOODS_ROW; i++) {
      randomArray.push(dataGoods[getRandomValue(dataGoods)]);
    }
    return randomArray;
  };
  const trendArray = getRamdomGoods();

  return (
    <section className="bg-background w-full px-6 py-6 md:py-12 md:px-12 lg:px-24">
      <div className="flex justify-center gap-2 md:gap-4 lg:gap-8 items-center">
        <hr className="h-01 w-16 mobile:w-24 smart:w-40 md:w-60 lg:w-70 xl:w-80 border-none bg-gradient-to-r from-grStart to-grEnd" />
        <h2 className="font-crimson font-bold text-sm mobile:text-base md:text-lg lg:text-2xl xl:text-4xl leading-10 tracking-wider text-font">
          Trending Products
        </h2>
        <hr className="h-01 w-16 mobile:w-24 smart:w-40 md:w-60 lg:w-70 xl:w-80 border-none bg-gradient-to-l from-grStart to-grEnd" />
      </div>
      <GoodsSlider goodsList={trendArray} />
    </section>
  );
};
